<template>
  <div :class="[`sc-weather-widget ${$mq}`]">
    <div class="sc-weather-widget__block sc-weather-widget__block--top">
      <div class="sc-weather-widget__block-item">
        <r-icon
          :name="currentWeather.icon"
          :size="$mq === `r_medium` ? 64 : 100"
        />
      </div>
      <div class="sc-weather-widget__block-item">
        <r-text :size="$mq === `r_medium` ? 36 : 52">
          {{ currentWeather.temp }}°
        </r-text>
        <r-text :size="$mq === `r_medium` ? 12 : 16">{{
          $t(`weather-widget:type-${currentWeather.name}`)
        }}</r-text>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    currentWeather: {
      type: Object,
      required: true
    }
  }
};
</script>

<style lang="scss">
.sc-weather-widget {
  width: 100%;
  &__block {
    display: flex;
    align-items: flex-start;
    justify-content: space-between;
    &--top {
      .sc-weather-widget__block-item {
        &:first-child {
          width: 35%;
        }
        &:last-child {
          width: 40%;
          text-align: center;
        }
        div {
          margin-bottom: 4px !important;
          &:last-child,
          &:first-child {
            margin-bottom: 0 !important;
          }
        }
      }
    }
  }
}
</style>

<i18n>
{
  "ru": {
    "weather-widget:type-Thunderstorm": "Гроза",
    "weather-widget:type-Drizzle": "Морось",
    "weather-widget:type-Rain": "Дождь",
    "weather-widget:type-Snow": "Снег",
    "weather-widget:type-Clear": "Безоблачно",
    "weather-widget:type-Clouds": "Облачно",

    "weather-widget:type-Mist": "Туман",
    "weather-widget:type-Smoke": "Дымка",
    "weather-widget:type-Haze": "Мгла",
    "weather-widget:type-Dust": "Пыль",
    "weather-widget:type-Fog": "Туман",
    "weather-widget:type-Sand": "Калима",
    "weather-widget:type-Ash": "Зола",
    "weather-widget:type-Squall": "Шквал",
    "weather-widget:type-Tornado": "Ураган"
  },
  "en": {
    "weather-widget:type-Thunderstorm": "Thunderstorm",
    "weather-widget:type-Drizzle": "Drizzle",
    "weather-widget:type-Rain": "Rain",
    "weather-widget:type-Snow": "Snow",
    "weather-widget:type-Clear": "Clear sky",
    "weather-widget:type-Clouds": "Clouds",

    "weather-widget:type-Mist": "Mist",
    "weather-widget:type-Smoke": "Smoke",
    "weather-widget:type-Haze": "Haze",
    "weather-widget:type-Dust": "Dust",
    "weather-widget:type-Fog": "Fog",
    "weather-widget:type-Sand": "Sand",
    "weather-widget:type-Ash": "Ash",
    "weather-widget:type-Squall": "Squall",
    "weather-widget:type-Tornado": "Tornado"
  }
}
</i18n>
